import { render } from "./validation-detail-user.vue?vue&type=template&id=4bea991c"
import script from "./validation-detail-user.vue?vue&type=script&lang=js"
export * from "./validation-detail-user.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__